function isError(error) {
    return error instanceof Error;
}
export default function toError(maybeError) {
    if (isError(maybeError)) {
        return maybeError;
    }
    try {
        return new Error(JSON.stringify(maybeError));
    } catch (e) {
        // fallback in case there's an error stringifying the maybeError
        // like with circular references for example.
        return new Error(String(maybeError));
    }
}

//# sourceMappingURL=toError.js.map